// App.js
import React from 'react'
import styled from 'styled-components'



const Card = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;
  padding: 2px;
`

const CompanyName = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  color: #000000;
`


const ExceptionBrand = ({ companies }) => {
  return (
    <Card>
      {companies?.map((company, index) => (
        <CompanyName key={company?.corporateId}>
          {company?.corporateName}
        </CompanyName>
      ))}
    </Card>
  )
}

export default ExceptionBrand
